import { Footer } from "./components/footer";
import {HomePageHeader, HomePageHeaderHandle} from "./components/header";
import {PageTabs, PAGE_TABS, NavBar, PAGE_TABS_NAMES} from "./components/nav-bar";
import {useRef} from "react";
import {CvSubpage} from "./subpages/work/cv-subpage";
import {ProjectsSubpage} from "./subpages/work/projects-subpage";
import {CertificationsSubpage} from "./subpages/work/certifications-subpage";
import {useSearchParams} from "react-router-dom";
import {usePageTitle} from "../../lib/page-title";

function getTab (v: string | null): PageTabs {
    if (PAGE_TABS.includes(v as PageTabs)) {
        return v as PageTabs;
    }
    return "projects";
}
export function HomePage () {
    const [params, setParams] = useSearchParams();
    const tab = getTab(params.get("tab"));
    const setTab = (tab: PageTabs) => setParams(p => {
        p.set("tab", tab);
        return p;
    })
    const headerRef = useRef<HomePageHeaderHandle>(null);
    const onTabSelected = (tab: PageTabs) => {
        headerRef.current?.scrollToContent();
        setTab(tab);
    }

    usePageTitle(`Moritz Bruder: ${PAGE_TABS_NAMES[tab]}`);

    return <div className={"flex flex-col items-center"}>
        <HomePageHeader ref={headerRef} />
        <NavBar tab={tab} onTabSelected={onTabSelected} />

        <div className={"h-0 md:h-16"}></div>

        <Content selectedTab={tab} />

        <Footer />
    </div>
}

function Content ({ selectedTab }: { selectedTab: PageTabs }) {
    if (selectedTab === "cv") {
        return <CvSubpage />;
    } else if (selectedTab === "projects") {
        return <ProjectsSubpage />;
    } else if (selectedTab === "certificates") {
        return <CertificationsSubpage />
    }

    throw new Error("Unknown tab " + selectedTab);
}